import api from '../api';

class DownloadManagerApi {

    getDownloadFileStorage = (endpoint,brand) => {
        return api.get(`${endpoint}/spreadsheets/export?brand=${brand}`, {data: ''});
    }

    postDownloadFileStorage = (endpoint,brand,filterOptions) => {
        return api.post(`${endpoint}/spreadsheets/export?brand=${brand}${filterOptions}`, {data: ''});
    }

}

const instance = new DownloadManagerApi();

export default instance;